export function focusable(el) {
  return Array.from(
    el.querySelectorAll(
      'summary, button:not(:disabled), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' // eslint-disable-line max-len
    )
  );
}
